import { apiClient, handleApiRequest } from './client'

export interface EmailActionLesson {
  lesson_request_id: string
  date: string
  time: string
  subject: string
  class: string
  room: string
  status: string
  assigned_teacher_id?: string | null
  date_iso?: string
}

export interface EmailActionDay {
  date: string
  label: string
  lesson_count: number
}

export interface EmailActionDecision {
  date: string
  decision: 'accept' | 'decline'
}

export interface EmailActionContext {
  state: string
  action: string
  action_kind: string
  auto_confirm?: boolean
  preselect: 'interested' | 'decline' | 'open'
  teacher_name: string
  request_id: string
  viewer_teacher_id?: string | null
  subject_name: string | null
  klass_name: string | null
  school_name: string
  deadline: string | null
  lessons: EmailActionLesson[]
  message: string
  affected_request_count?: number
  is_bulk?: boolean
  login_token?: string | null
  days?: EmailActionDay[]
  entry_date?: string
  entry_intent?: 'accept' | 'decline'
  requester_name?: string
  date_display?: string
}

export interface EmailActionResult {
  state: string
  message: string
  action?: string
  count?: number
  already_taken?: number
  login_token?: string | null
}

export interface EmailLoginResponse {
  state: string
  valid: boolean
  message: string
  access_token?: string
  refresh_token?: string
  redirect_url?: string
}

export const emailActionApi = {
  resolve: (token: string, action?: string) =>
    handleApiRequest<EmailActionContext>(
      apiClient.get(`/api/v1/email/actions/${token}`, {
        params: action ? { action } : undefined,
      }),
    ),

  respond: (
    token: string,
    action?: string,
    decisions?: EmailActionDecision[],
    choice?: 'interested' | 'decline',
  ) =>
    handleApiRequest<EmailActionResult>(
      apiClient.post(
        `/api/v1/email/actions/${token}/respond`,
        {
          ...(decisions ? { decisions } : {}),
          ...(choice ? { choice } : {}),
        },
        { params: action ? { action } : undefined },
      ),
    ),

  login: (token: string) =>
    handleApiRequest<EmailLoginResponse>(
      apiClient.post(`/api/v1/email/actions/${token}/login`),
    ),
}
